// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.News_NewsDesktop__tYGFL {
  width: 60px;
  background-color: #E0FFFF;
  transition: width 0.5s ease-in-out;
  cursor: pointer;
}

.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O {
  width: calc(50vw - 180px);
  background-color: #E0FFFF;
  height: 100vh;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 {
  width: calc(50vw - 180px);
  padding: 106px 65px 30px 66px;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_tabTitle__PR98D {
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 40px;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG {
  margin-bottom: 54px;
  cursor: pointer;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a {
  text-decoration: none;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a img {
  max-width: 100%; /* Ensures the image doesn't exceed its container */
  height: auto; /* Maintains the aspect ratio of the image */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */
  margin-bottom: 40px;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a span {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a .News_divider__mxdRw {
  margin: 16px 0 12px;
  border-bottom: 3px solid #140C0F;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a .News_source__fh3m7 {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
}
.News_tableDesktop__LxGB3 .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_copyright__6vjV5 {
  margin: 90px 0 30px;
}

.News_selectedDesktop__RcxZ2 {
  cursor: default;
  width: calc(50vw - 180px);
}

.News_NewsTablet__cD3Hl {
  width: 100vw;
  background-color: #E0FFFF;
  cursor: pointer;
}

.News_tableTablet__P7AVm .News_closeIcon__F2Ytu {
  position: fixed;
  right: 30px;
  top: 28px;
  z-index: 2;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O {
  background-color: #E0FFFF;
  height: 100vh;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 {
  padding: 112px 24px 30px 24px;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_tabTitle__PR98D {
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 40px;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG {
  margin-bottom: 54px;
  cursor: pointer;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a {
  text-decoration: none;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a img {
  max-width: 100%; /* Ensures the image doesn't exceed its container */
  height: auto; /* Maintains the aspect ratio of the image */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */
  margin-bottom: 40px;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a span {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a .News_divider__mxdRw {
  margin: 16px 0 12px;
  border-bottom: 3px solid #140C0F;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_news__INtJG a .News_source__fh3m7 {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
}
.News_tableTablet__P7AVm .News_scrollBar__jk3\\+O .News_content__fvLO0 .News_copyright__6vjV5 {
  margin-top: 64px;
}

.News_selectedTablet__g6nbQ {
  cursor: default;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}`, "",{"version":3,"sources":["webpack://./src/tabs/News/News.module.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,WCFU;EDGV,yBCQK;EDPL,kCC+Be;ED9Bf,eAAA;AADF;;AAKE;EACE,yBAAA;EACA,yBAAA;EACA,aAAA;AAFJ;AAII;EACE,yBAAA;EACA,6BAAA;AAFN;AAIM;EC6HJ,kCAtGkB;EAuGlB,eA1Fa;EA2Fb,iBAtFe;EAuFf,cA7IgB;EA8IhB,gBAvGW;EDxBL,mBAAA;AAER;AACM;EACE,mBAAA;EACA,eAAA;AACR;AACQ;EACE,qBAAA;AACV;AACU;EACE,eAAA,EAAA,mDAAA;EACA,YAAA,EAAA,4CAAA;EACA,uCAAA,EAAA,yBAAA;EACA,mBAAA;AACZ;AAEU;ECkGR,kCA9FkB;EA+FlB,eAnFa;EAoFb,iBA9Ee;EA+Ef,cArIgB;EAsIhB,gBA/FW;ADFb;AADU;EACE,mBAAA;EACA,gCAAA;AAGZ;AAAU;ECuCR,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;AD+ClB;AAAQ;EACE,mBAAA;AAEV;;AAKA;EACE,eAAA;EACA,yBAAA;AAFF;;AAKA;EACE,YAAA;EACA,yBCxDK;EDyDL,eAAA;AAFF;;AAOE;EC7CA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AD0CF;AAGE;EACE,yBClEG;EDmEH,aAAA;AADJ;AAGI;EACE,6BCjEsB;ADgE5B;AAGM;EC4DJ,kCAtGkB;EAuGlB,eA1Fa;EA2Fb,iBAtFe;EAuFf,cA7IgB;EA8IhB,gBAvGW;EDyCL,mBAAA;AAGR;AAAM;EACE,mBAAA;EACA,eAAA;AAER;AAAQ;EACE,qBAAA;AAEV;AAAU;EACE,eAAA,EAAA,mDAAA;EACA,YAAA,EAAA,4CAAA;EACA,uCAAA,EAAA,yBAAA;EACA,mBAAA;AAEZ;AACU;ECiCR,kCA9FkB;EA+FlB,eAnFa;EAoFb,iBA9Ee;EA+Ef,cArIgB;EAsIhB,gBA/FW;ADgEb;AAFU;EACE,mBAAA;EACA,gCAAA;AAIZ;AADU;EC1BR,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;ADiHlB;AADQ;EACE,gBAAA;AAGV;;AAIA;ECzGE,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;ADyGF","sourcesContent":["@import \"src/styles/variables\";\n\n.NewsDesktop {\n  width: $tab-width;\n  background-color: $News;\n  transition: $tab-transition;\n  cursor: pointer;\n}\n\n.tableDesktop {\n  .scrollBar {\n    width: calc(50vw - 180px);\n    background-color: $News;\n    height: 100vh;\n\n    .content {\n      width: calc(50vw - 180px);\n      padding: 106px 65px 30px 66px;\n\n      .tabTitle {\n        @include font-title-48;\n        margin-bottom: 40px;\n      }\n\n      .news {\n        margin-bottom: 54px;\n        cursor: pointer;\n\n        a {\n          text-decoration: none;\n\n          img {\n            max-width: 100%; /* Ensures the image doesn't exceed its container */\n            height: auto; /* Maintains the aspect ratio of the image */\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */\n            margin-bottom: 40px;\n          }\n\n          span {\n            @include font-title-32;\n          }\n\n          .divider {\n            margin: 16px 0 12px;\n            border-bottom: 3px solid $sub-title-color;\n          }\n\n          .source {\n            @include font-16;\n          }\n        }\n\n      }\n        .copyright {\n          margin: 90px 0 30px;\n        }\n    }\n  }\n}\n\n\n.selectedDesktop {\n  cursor: default;\n  width: calc(50vw - #{$not-active-tabs-width});\n}\n\n.NewsTablet {\n  width: 100vw;\n  background-color: $News;\n  cursor: pointer;\n}\n\n.tableTablet {\n\n  .closeIcon {\n    @include closeIcon;\n  }\n  .scrollBar {\n    background-color: $News;\n    height: 100vh;\n\n    .content {\n      padding: $mobile-tab-tablet-padding;\n\n      .tabTitle {\n        @include font-title-48;\n        margin-bottom: 40px;\n      }\n\n      .news {\n        margin-bottom: 54px;\n        cursor: pointer;\n\n        a {\n          text-decoration: none;\n\n          img {\n            max-width: 100%; /* Ensures the image doesn't exceed its container */\n            height: auto; /* Maintains the aspect ratio of the image */\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */\n            margin-bottom: 40px;\n          }\n\n          span {\n            @include font-title-32;\n          }\n\n          .divider {\n            margin: 16px 0 12px;\n            border-bottom: 3px solid $sub-title-color;\n          }\n\n          .source {\n            @include font-16;\n          }\n        }\n\n      }\n        .copyright {\n          margin-top: 64px;\n        }\n    }\n  }\n}\n\n\n.selectedTablet {\n  @include selectedTablet;\n}","//tab sizes\n$tab-width: 60px;\n$not-active-tabs-width: 180px;\n\n//fonts colors\n$title-color: #191114;\n$sub-title-color: #140C0F;\n$footer-color: #323433;\n\n//tabs colors\n$aboutUs: #0085FF;\n$Business: #69B4FF;\n$News: #E0FFFF;\n$Contact: #70E072;\n$MessageSent: #A5F2A6;\n\n//def padding\n$mobile-tab-tablet-padding: 112px 24px 30px 24px;\n\n//def tab content styles\n@mixin selectedTablet {\n  cursor: default;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n@mixin closeIcon {\n  position: fixed;\n  right: 30px;\n  top: 28px;\n  z-index: 2;\n}\n\n//transitions\n$tab-transition: width .5s ease-in-out;\n$left-content-transition-1: opacity .7s ease-in-out;\n$left-content-transition-2: opacity 3s ease-in-out;\n\n//fonts values\n$font-family-main: 'Inter', sans-serif;\n$font-family-title: 'Poppins', sans-serif;\n\n$font-w-400: 400;\n$font-w-700: 700;\n\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-16: 16px; //150%\n$font-size-18: 18px; //150%\n$font-size-20: 20px; // 150%\n$font-size-22: 22px;\n$font-size-24: 24px; //150%\n$font-size-32: 32px; //100%\n$font-size-48: 48px; //80%\n\n$font-size-179: 179px; //80%\n\n$font-line-150p: 150%;\n$font-line-100p: 100%;\n$font-line-80p: 80%;\n\n//font variants\n@mixin font-title-179 {\n  font-family: $font-family-title;\n  font-size: $font-size-179;\n  line-height: $font-line-80p;\n  font-weight: $font-w-700;\n}\n\n@mixin font-13 {\n  font-family: $font-family-main;\n  font-size: $font-size-13;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-14 {\n  font-family: $font-family-main;\n  font-size: $font-size-14;\n  line-height: 16px;\n  color: $sub-title-color;\n}\n\n@mixin font-16 {\n  font-family: $font-family-main;\n  font-size: $font-size-16;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-18 {\n  font-family: $font-family-main;\n  font-size: $font-size-18;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20 {\n  font-family: $font-family-main;\n  font-size: $font-size-20;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20-title {\n  font-family: $font-family-title;\n  font-size: $font-size-20;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-22 {\n  font-family: $font-family-title;\n  font-size: $font-size-22;\n  line-height: $font-line-80p;\n  color: $sub-title-color;\n}\n\n@mixin font-24 {\n  font-family: $font-family-main;\n  font-size: $font-size-24;\n  line-height: $font-line-150p;\n  color: $title-color;\n  font-weight: $font-w-400;\n}\n\n@mixin font-24-bold {\n  @include font-24;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-32 {\n  font-family: $font-family-title;\n  font-size: $font-size-32;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-48 {\n  font-family: $font-family-title;\n  font-size: $font-size-48;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NewsDesktop": `News_NewsDesktop__tYGFL`,
	"tableDesktop": `News_tableDesktop__LxGB3`,
	"scrollBar": `News_scrollBar__jk3+O`,
	"content": `News_content__fvLO0`,
	"tabTitle": `News_tabTitle__PR98D`,
	"news": `News_news__INtJG`,
	"divider": `News_divider__mxdRw`,
	"source": `News_source__fh3m7`,
	"copyright": `News_copyright__6vjV5`,
	"selectedDesktop": `News_selectedDesktop__RcxZ2`,
	"NewsTablet": `News_NewsTablet__cD3Hl`,
	"tableTablet": `News_tableTablet__P7AVm`,
	"closeIcon": `News_closeIcon__F2Ytu`,
	"selectedTablet": `News_selectedTablet__g6nbQ`
};
export default ___CSS_LOADER_EXPORT___;
